export default __webpack_public_path__ + "static/media/Diamond-Hands.6d352f89.svg";